export var EmoteStreamType;
(function(EmoteStreamType) {
    EmoteStreamType["OFFICIAL"] = "official";
    EmoteStreamType["COMMUNITY"] = "community";
    EmoteStreamType["SEARCH"] = "search";
    EmoteStreamType["USER"] = "user";
})(EmoteStreamType || (EmoteStreamType = {}));
